import { RootState } from '../../store';

export const getAllNetworkRequest = (state: RootState) =>
  state.networkRequestStore.networkRequests;

export const getPagesVisted = (state: RootState) => state.networkRequestStore.pagesVisted;
